import { translateField } from "@cdv/jazz-i18n";
import { Box, Button, Card, CardContent, Divider, Stack, Typography } from "@mui/material";
import { ReactElement, useContext } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { useNavigate } from "react-router";
import { ActionType, AppContext } from "@cdv/jazz-ui";

export default function Help(): ReactElement {
  const sx = { color: "#00000099", mt: "15px" };
  return (
    <>
      <AppBar title={translateField(Resource.Info, "help")} />

      <Card sx={{ mx: "16px", mt: "0 !important", borderRadius: 0, boxShadow: "none" }}>
        <CardContent sx={{ mt: 0 }}>
          <Box>
            <Stack spacing={2} sx={{ alignItems: "center" }}>
              <img src="/assets/ilustr_INFO_05.svg" style={{ height: "150px" }} />
              <Typography variant="h5" align="center">
                Požádejte o pomoc
              </Typography>
              <Typography sx={sx}>
                Pokud potřebujete pomoc s používáním aplikace, kontaktujte nás prosím
                prostřednictvím sekce Kontakt.
              </Typography>
            </Stack>
          </Box>

          <Stack direction="column" sx={{ alignItems: "center", gap: 2 }}>
            <Box>
              <Stack sx={{ alignItems: "center" }}>
                <img src="/assets/ilustr_INFO_06_logoLPPP.jpg" alt="" style={{ height: "113px" }} />
              </Stack>

              <Typography sx={sx}>
                Ideální volba pro dospělé řidiče. Pomáhá při akutním stresu, přepracování, úzkostech
                i po náročných situacích na silnici (nehody, úrazy). <br />
                <strong>
                  <a href="tel:+420 116 123" style={{ color: "#00000099", textDecoration: "none" }}>
                    +420 116 123
                  </a>
                </strong>
              </Typography>
              <Button
                variant="contained"
                color="inherit"
                size="large"
                fullWidth
                sx={{ mt: "10px" }}
                href="https://linkapsychickepomoci.cz/"
              >
                navštívit web
              </Button>
              <Divider sx={{ my: 1, borderColor: "#949396" }} />
            </Box>
            <Box>
              <Stack sx={{ alignItems: "center" }}>
                <img src="/assets/ilustr_INFO_07_logoML.jpg" alt="" style={{ height: "113px" }} />
              </Stack>

              <Typography sx={sx}>
                Krizová linka důvěry fungující nonstop (zde se platí běžný tarif operátora). Nabízí
                možnost probrat samotu, únavu i stres za volantem. <br />
                <strong>
                  <a
                    href="tel:+420 608 902 410"
                    style={{ color: "#00000099", textDecoration: "none" }}
                  >
                    +420 608 902 410
                  </a>
                </strong>
              </Typography>
              <Button
                variant="contained"
                color="inherit"
                size="large"
                fullWidth
                sx={{ mt: "10px" }}
                href="https://modralinka.cz/"
              >
                navštívit web
              </Button>
              <Divider sx={{ my: 1, borderColor: "#949396" }} />
            </Box>
            <Box>
              <Stack sx={{ alignItems: "center" }}>
                <img src="/assets/ilustr_INFO_08_logoBKB.jpg" alt="" style={{ height: "113px" }} />
              </Stack>

              <Typography sx={sx}>
                Vhodné, pokud jste se stali obětí trestného činu (například agresivita, napadení)
                nebo vážné dopravní nehody <br />
                <strong>
                  <a href="tel:+420 116 006" style={{ color: "#00000099", textDecoration: "none" }}>
                    +420 116 006
                  </a>
                </strong>
              </Typography>
              <Button
                variant="contained"
                color="inherit"
                size="large"
                fullWidth
                sx={{ mt: "10px" }}
                href="https://www.bkb.cz/"
              >
                navštívit web
              </Button>
              <Divider sx={{ my: 1, borderColor: "#949396" }} />
            </Box>
            <Box>
              <Stack sx={{ alignItems: "center" }}>
                <img src="/assets/ilustr_INFO_09_logoFNB.jpg" alt="" style={{ height: "113px" }} />
              </Stack>

              <Typography sx={sx}>
                LInka pro všechny, kdo se se ocitnou v situaci, kterou vnímají jako obtížnou a těžko
                řešitelnou.
                <br />
                Telefonická služba - linka pro krizovou intervenci
                <br />
                <strong>
                  <a
                    href="tel:+420 532 232 078"
                    style={{ color: "#00000099", textDecoration: "none" }}
                  >
                    +420 532 232 078
                  </a>
                </strong>
              </Typography>
              <Button
                variant="contained"
                color="inherit"
                size="large"
                fullWidth
                sx={{ mt: "10px" }}
                href="https://www.fnbrno.cz/areal-bohunice/psychiatricka-klinika/telefonicka-sluzba-linka-pro-krizovou-intervenci/t7875"
              >
                navštívit web
              </Button>
              <Divider sx={{ my: 1, borderColor: "#949396" }} />
            </Box>
            <Box>
              <Stack sx={{ alignItems: "center" }}>
                <img src="/assets/ilustr_INFO_10_logoLB.jpg" alt="" style={{ height: "113px" }} />
              </Stack>

              <Typography sx={sx}>
                Vhodné, pokud je stres vyvolán tím, že se řidič stal obětí trestného činu (např.
                agresivita na silnicích, napadení) nebo vážné dopravní nehody.
                <br />
                <strong>
                  <a href="tel:+420 116 111" style={{ color: "#00000099", textDecoration: "none" }}>
                    +420 116 111
                  </a>
                </strong>
              </Typography>
              <Button
                variant="contained"
                color="inherit"
                size="large"
                fullWidth
                sx={{ mt: "10px" }}
                href="https://www.linkabezpeci.cz/"
              >
                navštívit web
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
